<template>
    <div>
        <div class="list">
            <div class="head" @click.stop="showList = !showList">室内热点列表  <span>(共{{list.length}}个)</span> <i :class="['iconfont','iconshousuo',showList ? '' : 'hidden']"></i></div>
            <ul class="body" :style="{height: showList ? '340px' : 0}" v-show="list.length > 0">
                <li v-for="item in list" :key="item.id">
                    <span><i class="iconfont iconziyuanguanliqi-redian-moren"></i> {{item.text}}</span>
                    <span><i @click.stop="edit(item)" class="iconfont iconxiugaibianji"></i> <i @click.stop="toDelete(item)" class="iconfont iconshanchu"></i></span>
                </li>
            </ul>
            <div :style="{height: showList ? '340px' : 0}" v-show="list.length == 0" class="empty body">
                <img src="@/assets/img/none.png" />
                <p>暂无室内热点</p>
            </div>
        </div>
        <div class="mask" v-if="showDialog">
            <div class="inner">
                <div class="head">室内热点添加 <i class="iconfont iconguanbi" @click.stop="showDialog = false"></i></div>
                <div class="form">
                    <p> <span>名称</span> <el-input type="text" placeholder="请输入热点名称" v-model="input" maxlength="10" show-word-limit></el-input> </p>
                    <button @click="confirm">确认</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import uuid from 'uuidjs'
export default{
    data(){
        return {
            showList: true,
            showDialog: false,
            list: [],
            input: '',
            billboardInfo: null
        }
    },

    computed: {
        billBoard2(){
            return window.billBoard2
        }
    },

    mounted(){
        this.updateList()
    },

    methods: {
        init( intersects ){
            intersects = intersects.filter( item => {
                return item.object.type == 'Mesh' || item.object.type == 'Object3D'
            } )
            var object, intersect = intersects[ 0 ]
            if ( intersects.length > 0 ) {
                object = AMRT.Utils.getModelNode( intersect.object )
            }
            if( object ){
                if( !object.mid ){
                    return this.$message.warning('该模型不支持添加热点')
                }
                let child = this.billBoard2.group.children.find(item => item.userData.mid == object.mid )
                if( child ){
                    return this.$message.info('该模型已经添加了热点，不能重复添加')
                }
                var position = object.worldToLocal( intersect.point )
                this.billboardInfo = {
                    id: '',
                    text: '',
                    position: position.toArray(),
                    mid: object.mid
                }
                this.input = ''
                this.showDialog = true
            }
        },

        edit( data ){
            this.input = data.text
            this.billboardInfo = data
            this.showDialog = true
        },

        toDelete( data ){
            let child = this.billBoard2.group.children.find(item => item.userData.id == data.id )
            this.billBoard2.remove( child )
            this.updateList()
        },

        confirm(){
            this.billboardInfo.text = this.input
            if( this.billboardInfo.id ){
                let child = this.billBoard2.group.children.find(item => item.userData.id == this.billboardInfo.id )
                this.billBoard2.remove( child )
            }else{
                this.billboardInfo.id = uuid.genV4().toString()
            }
            this.billBoard2.add( this.billboardInfo, () => {
                this.showDialog = false
                this.updateList()
            })
        },

        updateList(){
            this.list = this.billBoard2.export()
        }
    }

}
</script>
<style lang="scss" scoped>
.list{
    position: fixed; top: 45vh; right: 420px; width: 260px; background-color: rgba(242, 244, 246, 1); overflow-y: scroll; border-radius: 4px; z-index: 2; color: #182C49;
    &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .head{ 
        background-color: #fff;width: calc(100% - 20px); height: 34px; display: flex; align-items: center; padding: 0 10px; position: relative; font-size: 14px; position: sticky; top: 0; z-index: 1; cursor: pointer; 
        span{opacity: 0.5;}
        .iconfont{ position: absolute; right: 10px; top: 10px; transition: 1s transform; }
        .hidden{ transform: rotate(180deg); }
    }
    .body{
        background-color: rgba(242, 244, 246, 1); height: 340px; transition: height .5s; overflow: hidden;
        li{ 
            height: 34px; line-height: 34px; padding: 0 10px; display: flex; justify-content: space-between; align-items: center;  width: calc(100% - 20px); cursor: pointer;
            span:nth-child(1){
                display: block; width: 80%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; 
                .iconfont{color: #1458EA; position: relative; top: 1px; margin-right: 5px;}
            }
            .iconfont{font-size: 18px;}
            .iconfont:hover{ color: #1458EA; }
        }
        li:hover{
            background-color: rgba(20, 88, 234, .1);
        }
    }
    .empty{
        display: flex; flex-direction: column; justify-content: center; align-items: center;
        img{width: 73px; margin-bottom: 10px; opacity: 0.5;}
        p{opacity: 0.5;}
    }
}
.mask{ 
    width: 100vw; height: 100vh; position: fixed; justify-content: center; align-items: center; top: 0; left: 0; z-index: 9; background-color: rgba(0, 0, 0, 0.5); display: flex;
    .inner{
        width: 350px; height: 210px; background-color: #F2F4F6;
        .head{
            background-color: #fff;width: calc(100% - 20px); height: 34px; display: flex; align-items: center; padding: 0 10px; position: relative; font-size: 14px; position: sticky; top: 0; z-index: 1;
            .iconfont{ position: absolute; right: 10px; top: 10px; cursor: pointer; transition: 1s transform; }
            .iconfont:hover{ transform: scale(1.2); }
        }
        .form{
            display: flex; justify-content: center; flex-direction: column;
            p{
                margin: 30px 0; display: flex; justify-content: center;
                span{line-height: 40px; opacity: 0.5; font-size: 14px; margin-right: 10px; }
                /deep/ .el-input{width: 70%;}
            }
            button{ background-color: #1458EA; width: 140px; height: 34px; line-height: 34px; text-align: center; color: #FFF; border-radius: 34px; margin: 0 auto; cursor: pointer; }
        }
    }
}
</style>